"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function connectDevTools(store) {
    var devToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION__;
    if (!devToolsExtension) {
        console.warn("DevTools are not installed. For information see https://react-rx-state.netlify.com/dev-tools");
        // mock cleanup function
        return function () { };
    }
    var devTools = devToolsExtension.connect({
        name: store.options.storeName
    });
    devTools.subscribe(function (msg) {
        if (msg.type === "DISPATCH" &&
            msg.state &&
            msg.payload &&
            (msg.payload.type === "JUMP_TO_ACTION" ||
                msg.payload.type === "JUMP_TO_STATE" ||
                msg.payload.type === "ROLLBACK")) {
            // console.log("DevTools requested to change the state to:", msg.state)
            store.next(JSON.parse(msg.state), {
                type: "@RX_DEV_TOOLS/" + msg.payload.type
            });
        }
    });
    devTools.init(store.state);
    var storeSub = store.state$.subscribe(function (pack) {
        var state = pack.state, message = pack.message;
        if (message.type.indexOf("@RX_DEV_TOOLS") === -1) {
            devTools.send({ type: message.type, payload: state }, state);
        }
    });
    var cleanup = function () {
        storeSub.unsubscribe();
        devToolsExtension.disconnect();
    };
    return cleanup;
}
exports.connectDevTools = connectDevTools;
//# sourceMappingURL=connect-dev-tools.js.map